import React from 'react'
import moment from 'moment'
import styled from 'styled-components'
import { FieldWrapper } from '@progress/kendo-react-form'
import { DatePicker } from '@progress/kendo-react-dateinputs'
import { Label } from '@progress/kendo-react-labels'

export default ({ name, label, form }) => {
    let initialValue = form.valueGetter(name)
    if (initialValue !== null && initialValue !== undefined && initialValue !== '' && moment(initialValue) !== 'Invalid Date') {
        initialValue = moment(initialValue).toDate()
    } else {
        initialValue=null
    }
    const handleChange = (e) => {
        const value = moment(e.target.value).format('YYYY-MM-DD')
        form.onChange(name, {value})
    }

    return (
        <FieldWrapper>
            <StyledLabel editorId={name}>{label}</StyledLabel>
            <DatePicker format="dd.MM.yyyy" id={name} name={name} defaultValue={initialValue} onChange={handleChange} />
        </FieldWrapper>
    )
}

const StyledLabel = styled(Label)`
    font-size: 12px;
    color: rgba(0,0,0,0.6);
    display: block;
    padding-top: 4px;
`



// WEBPACK FOOTER //
// ./src/components/common/DatePickerField.js